// extracted by mini-css-extract-plugin
export default {"EditProfile":"EditProfile_EditProfile__t0U00","form":"EditProfile_form__l+8ZM","userImage":"EditProfile_userImage__CttBu"};